let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kj2BA")).then(() => parcelRequire('2auNn'));